export default {
      id: "icon-youtube-widget-usage",
      viewBox: "0 0 34 28",
      url: __webpack_public_path__ + "icons.svg#icon-youtube-widget",
      toString: function () {
        return this.url;
      }
    }